import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router";
import { useOrganizationDetails } from "hooks/api/fulfillment/organization";
import useUser from "hooks/reduxContainer/_common/useUser";
import { useRolesIndex } from "hooks/api/common/roles";
import Loader from "components/Loader/Loader";
import { get } from "lodash-es";
import { PlusOutlined } from "@ant-design/icons";
import { Button, notification } from "antd";
import UserRolesTable from "./UserRolesTable";
import { OPS_ONLY } from "config/roleConfig";

const OrganizationUserRolesIndexPage = (props) => {
  const history = useHistory();
  const params = useParams();
  const { user } = useUser();
  const { fetchOrganizationDetails, organizationDetails } = useOrganizationDetails();
  const { fetchRolesIndex, rolesIndex } = useRolesIndex();
  const organizationID = get(params, "organization_id");

  const query = { organization_id: organizationID };

  // eslint-disable-next-line
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    fetchOrganizationDetails(organizationID);
    fetchRolesIndex(query);
  }, []);

  const error = organizationDetails.error || rolesIndex.error;

  useEffect(() => {
    if (error) {
      notification.error({
        message: "Error",
        description: error,
      });
    }
  }, [error]);

  const allDataLoaded = organizationDetails.data && rolesIndex.data;
  const loading = organizationDetails.loading || rolesIndex.loading;

  if (!allDataLoaded && loading) return <Loader />;
  if (!organizationDetails.data || !rolesIndex.data) return null;

  const renderTable = () => {
    return <UserRolesTable isLoading={rolesIndex.loading} data={rolesIndex.data} />;
  };

  const goToOrganizationDetailPage = () => {
    history.push(`/organizations/${organizationID}`);
  };

  const goToOrganizationUserRolesCreateEditPage = () => {
    history.push(`/organizations/${organizationID}/roles/create`);
  };

  const organizationName = get(organizationDetails.data, "name", "");

  return (
    <div id="fulfillment-role-management-page" className="page-container">
      <div className="org-name-with-add-btn">
        <div className="organization-name" onClick={goToOrganizationDetailPage}>
          {organizationName}
        </div>
        <Button
          icon={<PlusOutlined />}
          disabled={user.subrole && OPS_ONLY.includes(user.subrole)}
          onClick={goToOrganizationUserRolesCreateEditPage}
        >
          Add New Role
        </Button>
      </div>
      <div className="page-title">USER ROLES</div>
      {renderTable()}
    </div>
  );
};

export default OrganizationUserRolesIndexPage;
